<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue